jQuery(document).ready(function() {
    var ua = window.navigator.userAgent;
    var isIE = /MSIE|Trident/.test(ua);

    if (isIE) {
        var $elements = jQuery('.wp-block-image');
        $elements.each(function(key, element) {
            var $element = jQuery(element);
            $element.css('background-image', 'url(' + $element.find('img').prop('src') + ')');
        });
    }
});